<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
        <button v-if="scanKeyModalEnabled" @click="(event) => handleButtonPress(event)">Scan Key</button>
      </div>
      <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
    </div>


    <div class="currentView">
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector">
            <SearchBar class="gate-search" v-bind:search="search"
              v-bind:searchCallback="(data) => { this.performSearch(data) }" placeholder="Enter Search"
              :searchIcon="true" v-bind:exportDataCallback="() => exportData()"
              :updateDateRangeCallback="(dateRange) => updateDateRange(dateRange)"
              :clearFiltersCallback="() => clearFilters()" :filters="searchCategories"
              :searchCategoryUpdated="(category) => updateFilteredSearch(category, search)" :showSupportButtons="true"
              :updateFiltersCallback="(filters) => handleFilterUpdate(filters)"
              :filterConfiguration="filterConfiguration" />
          </div>
        </div>
        <DataTable v-bind:tableData="tableData" @options-changed="(data) => handleOptionsChange(data)"
          :headers="headers" v-bind:configuration="selectedItem" v-bind:processInputData="processInputData"
          :pagination="pagination" v-bind:openModalCallback="(data) => {
            handleModal(data);
          }" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../../ContentHeader";
import * as Constants from "../../../js/constants";
// import EventBus from "../../../eventBus";
import DataTable from "../pageComps/DataTable.vue";
import SearchBar from "../pageComps/Search.vue";
import CTSRepository from "../../../js/CTSRepository";
import { exportCSVFile } from "../../../js/ExportUtils";
import EntryLogModal from "../../modals/EntryLogModal.vue";
// import Insights from "../../layout/Insights.vue";

export default {
  name: "EntryLog",
  props: ["subPage", "organizationData", "userData"],
  components: {
    ContentHeader,
    DataTable,
    SearchBar,
    // Insights
  },
  data() {
    return {
      selectedItem: Constants.ENTRY_LOG,
      filterStartDate: null,
      filterEndDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      headerName: Constants.GATE,
      subHeader: "Below is a list of all visitors that have been scanned into the Community or manually entered by a guard",
      page: this.subPage ? this.subPage : "",
      defaultFilters: {
        residentName: null,
        visitorName: null,
        subdivision: null,
        status: null,
        startTime: null,
        endTime: null
      },
      filters: {},
      pagination: {},
      isLoading: false,
      searchFilters: {},
      searchCategories: [
        { value: "type", label: "Type" },
        { value: "entity_id", label: "ID" },
        { value: "action", label: "Action" },
        { value: "authorizer_first_name", label: "Authorizer" },
        { value: "visitor_first_name", label: "Visitor" },
        { value: "visiting_address", label: "Address" },
        { value: "visitor_contact", label: "Contact" },
        { value: "visitor_vendor_name", label: "Vendor" },
        { value: "visitor_license_plate", label: "License Plate" }
        // "authorizer_first_name": "",
        // "authorizer_last_name": "",
        // "visitor_first_name": "",
        // "visitor_last_name": "",
        // "visiting_address": "",
        // "visitor_license_plate": "",
        // "visitor_contact": "",
        // "visitor_vendor_name": "",
        // "party_key": ""
      ],
      filterConfiguration: [
        {
          sectionLabel: "Identification Information",
          sectionFields: [
            {
              displayLabel: "Visitor Name",
              key: "visitor_first_name",
              configuration: {
                type: 'input',
                placeholder: "Input"
              }
            },
            {
              displayLabel: "Resident Name",
              key: "resident_name",
              configuration: {
                type: 'input',
                placeholder: "Input"
              }
            },
            {
              displayLabel: "Guard Attendant",
              key: "authorizer_first_name",
              configuration: {
                type: 'input',
                placeholder: "Input"
              }
            }
          ]
        },
        {
          sectionLabel: "Visitor Type",
          sectionFields: [
            {
              displayLabel: "",
              key: "type",
              configuration: {
                type: 'select',
                options: [
                  { label: "Key", value: "Key" },
                  { label: "Vendor", value: "Vendor" },
                  { label: "Visitor", value: "Visitor" }
                ],
                placeholder: "Vendor"
              }
            }
          ]
        },
        {
          sectionLabel: "Visitor Entry Time",
          sectionFields: [
            {
              displayLabel: "Sort by",
              key: "sort_by",
              configuration: {
                type: 'select',
                options: [
                  { label: "Newest to Oldest (Newest First)", value: "desc" }
                ],
                placeholder: "Select"
              }
            }
          ]
        },
      ],
      selectedSearchCategory: null,
      tableData: [],
      mappedData: [],
      search: "",
      headers: [
        { text: "Visitor Name", value: "visitor_name", align: "start", sortable: true, width: 200 },
        { text: "Resident Name", value: "resident_name", filterable: true, width: 175 },
        { text: "Unit", value: "visiting_address", width: 175 },
        { text: "Visitor Entry Time", value: "readable_entry_time", filterable: false, width: 180 },
        { text: "Guard Attendant", value: "authorizer_name", filterable: false, width: 180 },
        { text: "Visitor License Plate", value: "visitor_license_plate", filterable: false, width: 175 },
        { text: "Visitor Contact", value: "visitor_contact", filterable: false, width: 180 },
        { text: "Visitor Type", value: "type", filterable: false, width: 180 },
      ],
    };
  },
  created() {
    var date = new Date();
    this.defaultEndDate = date.toISOString().split("T")[0];
    var startDate = new Date(date);
    startDate.setDate(date.getDate() - 7);
    //this.defaultStartDate = startDate.toISOString().split('T')[0]
    this.defaultStartDate = "2019-06-06";
    this.filters = this.defaultFilters
    this.performSearch("")
  },
  watch: {
    search() {
      this.filters = this.defaultFilters
      if (this.selectedSearchCategory != null) {
        this.updateFilteredSearch(this.selectedSearchCategory)
      }
    },
    organizationData() {
      this.performSearch("")
    }
  },
  methods: {
    performSearch(data, limit, page) {
      /* TODO: Handle Filters for Entry Log Search*/
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      this.search = data
      let finalFilters = this.searchFilters
      return new CTSRepository(this.$props.organizationData).searchEntryLog(finalFilters, limit, page)
        .then((data) => {
          console.log("Search Data", data);
          this.tableData = data.data
          this.pagination.totalItems = data.pagination.totalItems
          //resolve(data.data);
        })
        .catch((err) => {
          console.log("Error fetching Residents from Entry Log", err)
        })
        .finally(() => {
          this.isLoading = false
        });
    },
    fetchEntryLog() {
      new CTSRepository(this.$props.organizationData).fetchEntryLog().then(data => {
        this.tableData = data
      }).catch(err => console.log("Error fetching Entry Log", err))
    },
    updateFiltersForSearchBasedOnCard(card) {
      this.filters = card.filters ?? this.defaultFilters
      this.performSearch(this.search).then(() => {
      })
    },
    async handleOptionsChange(data) {
      console.log("Option Change Data", data)
      await this.performSearch(this.search, data.itemsPerPage, data.page)
      this.pagination = { ...this.pagination, ...data }
    },
    handleButtonPress() {
      this.$modal.show(Constants.SCAN_KEY_MODAL)
    },
    openGateModal() {
      this.$modal.show(Constants.GATE_MODAL);
    },
    exportData() {
      const headers = this.headers
        .map(h => h.text) // column labels
        .join(',')

      const rows = this.mappedData.map(item =>
        this.headers
          .map(h => {
            const value = item[h.value]
            return `"${(value ?? '').toString().replace(/"/g, '""')}"`
          })
          .join(',')
      )
      exportCSVFile(headers, rows, "entry_log_data.csv")
    },
    processInputData(inputData) {
      let mappedData = inputData.map(item => {
        let authorizer = "Community Tech"
        if (item.authorizer_first_name != null && item.authorizer_last_name != null) {
          authorizer = `${item.authorizer_first_name} ${item.authorizer_last_name}`
        }
        return {
          ...item,
          frequent_visitor_name: `${item.first_name} ${item.last_name}`,
          visitor_name: `${item.visitor_first_name} ${item.visitor_last_name}`,
          authorizer_name: authorizer,
          resident_name: `${item.resident_first_name} ${item.resident_last_name}`,
          readable_entry_time: `${new Date(item.time_entry).toLocaleString()}`,
        }
      })
      this.mappedData = mappedData
      return mappedData
    },
    updateFilteredSearch(category, data) {
      console.log(`Updating Filtered Search ${category}, ${data}`)
      if (category == null || category.trim() == "") {
        delete this.searchFilters[this.selectedSearchCategory]
        return;
      }
      if (data == null || data == undefined || data.trim() == "") {
        delete this.searchFilters[category]
        return;
      }
      console.log(`Updating Filtered Search ${category}, ${data}`)
      this.selectedSearchCategory = category
      this.searchFilters[category] = data
    },
    updateDateRange(dateRange) {
      this.searchFilters['start_time'] = dateRange[0]
      this.searchFilters['end_time'] = dateRange[1]
    },
    clearFilters() {
      this.searchFilters = {}
      this.performSearch("")
    },
    handleFilterUpdate(filters) {
      //window.alert(`from EntryLog - ${JSON.stringify(filters, null, 2)}`)
      Object.assign(this.searchFilters, filters)
      this.performSearch()
    },
    handleModal(item) {
      this.$modal.show(EntryLogModal, {
        entryLogData: item,
        organizationData: this.$props.organizationData,
        userData: this.$props.userData,
      }, {
        transition: "fade",
        top: "0",
        width: "650",
        height: "auto",
        draggable: "true",
        adaptive: false,
        styles: "border-radius: 22px;"
      })
    },

  },
  computed: {
    scanKeyModalEnabled: function () {
      const enabled = this.$featureEnabledForRole(Constants.SCAN_KEY_MODAL, this.$props.userData['custom:cts_role'])
      console.log("Is Scan Key Featured Enabled for Role", this.$props.userData['custom:cts_role'], enabled)
      return enabled
    }
  }
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 24px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 24px;
}

.filterIcon {
  margin-right: 16px;
}

input[type="text"]:focus {
  background-color: lightblue;
}

input[type="date"]:focus {
  outline: none;
  border: 0;
  appearance: none;
  border-width: 0px;
  border: none;
}

.pageHeader button {
  background-color: #1890FFCC !important;
}
</style>